import { useEffect } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FONTS = [["default", "Default (Sans)", "Arial, Helvetica, sans-serif"], ["montserrat", "Montserrat", "Montserrat"], ["poppins", "Poppins", "Poppins"], ["raleway", "Raleway", "Raleway"],
  ["oswald", "Oswald", "Oswald"], ["playfair-display", "Playfair Display", "'Playfair Display'"], ["merriweather", "Merriweather", "Merriweather"], ["lora", "Lora", "Lora"], ["roboto-slab", "Roboto Slab", "'Roboto Slab'"]];
const HREF = "https://fonts.googleapis.com/css2?family=Montserrat:wght@700&family=Poppins:wght@700&family=Raleway:wght@700&family=Oswald:wght@700&family=Playfair+Display:wght@700&family=Merriweather:wght@700&family=Lora:wght@700&family=Roboto+Slab:wght@700&display=swap";

export const HeadingFont = ({ Card }) => {
  const { settings, setSettings } = useAuth();
  useEffect(() => {
    if (document.getElementById("heading-font-previews")) return;
    const l = document.createElement("link");
    Object.assign(l, { id: "heading-font-previews", rel: "stylesheet", href: HREF });
    document.head.appendChild(l);
  }, []);
  if (!settings) return null;
  const cur = settings.heading_font || "default";
  const pick = async (v) => {
    try {
      const r = await api.put("/settings", { company_name: settings.company_name, currency: settings.currency, tiers: settings.tiers, notify_email: settings.notify_email || null, heading_font: v });
      setSettings(r.data); toast.success("Heading font saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title="Heading font (PDF & Word)" testId="settings-heading-font">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {FONTS.map(([k, name, family]) => (
          <button key={k} type="button" data-testid={`heading-font-${k}`} onClick={() => pick(k)}
            className={`text-left rounded-lg border p-4 transition-colors ${cur === k ? "border-emerald-500 bg-emerald-500/10" : "border-slate-800 hover:border-slate-600"}`}>
            <p className="text-xl text-white leading-tight mb-1" style={{ fontFamily: family, fontWeight: 700 }}>Market Analysis</p>
            <p className="text-xs text-slate-400">{name}{cur === k && <span className="ml-2 uppercase tracking-wider text-emerald-400">Active</span>}</p>
          </button>
        ))}
      </div>
      <p className="text-xs text-slate-500 mt-4">Used for titles and section headings; body text stays a clean sans-serif. PDFs always show the exact font. In Word, clients without the font installed see a similar substitute.</p>
    </Card>
  );
};
